import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PlanLoanMain } from '../plan/planone/services/planloanmain.service';
import { PlanoneService } from '../plan/planone/services/planone.service';
import { PlanthreeService } from '../plan/planthree/services/planthree.service';
import { PlantwoService } from '../plan/plantwo/services/plantwo.service';
import { AuthGuard } from '../services/auth-guard.service';
import { AuthGuardMenu } from '../services/auth-guard-menu.service';
import { DialogmenuplanComponent } from '../shared/components/dialogmenuplan/dialogmenuplan.component';
import { APP_CONFIG, AppConfig } from './../app.config'; // app config
import { AppRoutingModule } from './../app.routing';
import { PlanMainService } from './../plan/service/plan-main.service';
import { ConnectExtremeService } from './../services/connect-extreme.service';
import { GlobalvariableService } from './../services/globalvariable.service';
import { LoginService } from './../services/login.service';
import { MakerService } from './../services/maker.service';
import { NewCarService } from './../services/new-car.service';
import { NewsService } from './../services/news.service';
import { FukushaService } from './../services/fukusha.service';
import { PlanService } from './../services/plan.service';
import { SalesService } from './../services/sales.service';
import { ShareModule } from './../shared/shared.module';
import { HomeComponent } from './home/home.component';
import { OsusumeService } from '../services/osusume.service';
import { DataService } from '../services/data.service';
import { UtilService } from '../services/util.service';
import { UsedcarDetailService } from '../services/usedcar-detail.service';

@NgModule({
  declarations: [HomeComponent, DialogmenuplanComponent],
  imports: [ShareModule, AppRoutingModule, CommonModule],
  exports: [AppRoutingModule],
  providers: [
    ConnectExtremeService,
    PlanMainService,
    SalesService,
    MakerService,
    NewCarService,
    FukushaService,
    GlobalvariableService,
    NewsService,
    PlanService,
    PlanoneService,
    PlantwoService,
    PlanthreeService,
    PlanLoanMain,
    DataService,
    UtilService,
    { provide: APP_CONFIG, useValue: AppConfig },
    LoginService,
    AuthGuard,
    OsusumeService,
    AuthGuardMenu,
    UsedcarDetailService
  ]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts